export const STANDALONE_SITE_HOST = 'customhub.app';

export const getStandaloneSiteSubdomain = (domain?: string | null) => {
    const host = domain
        ?.trim()
        .replace(/^https?:\/\//i, '')
        .replace(/\/.*$/, '')
        .replace(/\.$/, '');

    if (!host) return undefined;

    const portalSuffix = `.${STANDALONE_SITE_HOST}`;
    return host.toLowerCase().endsWith(portalSuffix) ? host.slice(0, -portalSuffix.length) : host;
};

export const getStandaloneSiteDisplayDomain = (domain?: string | null) => {
    const subdomain = getStandaloneSiteSubdomain(domain);
    return subdomain ? `${subdomain}.${STANDALONE_SITE_HOST}` : undefined;
};

export const getStandaloneSitePublicUrl = (domain?: string | null) => {
    const displayDomain = getStandaloneSiteDisplayDomain(domain);
    return displayDomain ? `https://${displayDomain}` : undefined;
};
